import React from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { logOutUser } from "../../_actions/userActionCreator"
import { removeCachedData, removeSessionData } from "../../common/utils"

function LogOut(props) {
  const { logOutUser, history } = props
  removeCachedData("Qarabao_User")
  removeSessionData("Qarabao_User")
  logOutUser()
  history.push("/")
  return (
    <div className="LogOut">
      <h1>Loggin' out, eh?</h1>
    </div>
  )
}

export default connect(
  null,
  { logOutUser }
)(withRouter(LogOut))
